import React from 'react';
import HoverListDescription from '@/components/list/HoverListDescription';
import { isEmpty } from '@/utils/resultsHelper';
import { linkValue } from '../helper';

const FormLinkDescription = ({
  canEdit,
  field,
  showEdit,
  text,
  toolTip = 'top right',
}) => (
  <HoverListDescription
    canEdit={canEdit}
    className="aridhia-form-link-description form-description"
    editCopyMods="field-container"
    linkTarget={text?.target}
    markdown
    position="top"
    showEdit={showEdit}
    toolTip={toolTip}
    value={isEmpty(text) ? undefined : linkValue(text, field)}
  />
);

export default FormLinkDescription;
